import { Buffer } from 'buffer'
import { CipherJS } from '../CipherJS/CipherJS'

export const cipherString = (dataString: string, publicKey: string): Promise<string> =>
  new Promise((resolve, reject) => {
    if (!publicKey || !dataString) {
      alert('Chybi klic nebo vstupni data')
      reject()
    }
    // @ts-ignore
    const cipherJS = new CipherJS(publicKey)
    const dataBase64 = Buffer.from(dataString).toString('base64')
    cipherJS.encryptData(dataBase64, (resultCipher: ArrayBuffer) => {
      const sifra = Buffer.from(resultCipher).toString('base64')
      resolve(sifra)
    })
  })

export const cipherFile = (file: File, publicKey: string): Promise<Buffer> =>
  new Promise((resolve, reject) => {
    if (!publicKey || !file) {
      alert('Chybi klic nebo vstupni soubor')
      reject()
    }
    // @ts-ignore
    const cipherJS = new CipherJS(publicKey)
    cipherJS.encryptFile(file, (resultCipher: Buffer) => {
      resolve(resultCipher)
    })
  })

